import antiAddictionConfiguration from './antiAddiction/configuration';
import cpArgExport from './cpArgExport';
import demo from './demo';
import gameConfigPackagePlanManager from './gameConfig/PackagePlanManager';
import gameConfigActivityPageManager from './gameConfig/activityPageManager';
import gameConfigBaseInfo from './gameConfig/baseInfo';
import gameConfigCommonInfo from './gameConfig/commonInfo';
import gameConfigServer from './gameConfig/server';
import index from './index';
import ipBlock from './ipBlock';
import ipBlockView from './ipBlockView';
import noAccess from './noAccess';
import notfind from './notfind';
import payPackageSetting from './payPackageSetting';
import pushPushPlan from './push/PushPlan';
import pushPushPlanDetail from './push/PushPlanDetail';
import pushPushPlanManager from './push/PushPlanManager';
import pushPushPlanOperate from './push/PushPlanOperate';
import pushCes from './push/ces';
import pushDetail from './push/detail';
import pushOperateLoginBanUserList from './push/operateLoginBanUserList';
import pushTrysend from './push/trysend';
import queryActivityOrderDetail from './query/activityOrderDetail';
import queryActivityOrderList from './query/activityOrderList';
import queryActivityOrderResend from './query/activityOrderResend';
import queryLoginList from './query/loginList';
import queryPay from './query/pay';
import queryReg from './query/reg';
import querySdkReleaseRecord from './query/sdkReleaseRecord';
import queryTerminal from './query/terminal';
import queryUser from './query/user';
import rechargeCreateRechargeCode from './recharge/createRechargeCode';
import rechargePushRechargeCode from './recharge/pushRechargeCode';
import rechargeRechargeCodeList from './recharge/rechargeCodeList';
import riskManagementAutoBanSetting from './riskManagement/autoBanSetting';
import riskManagementDetail from './riskManagement/detail';
import riskManagementIpBlock from './riskManagement/ipBlock';
import riskManagementIpBlockView from './riskManagement/ipBlockView';
import riskManagementLoginBan from './riskManagement/loginBan';
import riskManagementOperateLoginBanUserList from './riskManagement/operateLoginBanUserList';
import sdkAdjustToken from './sdk/adjustToken';
import sdkConfigEdit from './sdk/configEdit';
import sdkConfigList from './sdk/configList';
import sdkDialog from './sdk/dialog';
import sdkReleasesEdit from './sdk/releasesEdit';
import sdkReleasesEdit1 from './sdk/releasesEdit1';
import sdkReleasesList from './sdk/releasesList';
import systemSdkVersion from './system/sdkVersion';
import watchAlarmGroup from './watch/alarmGroup';
import watchAlarmPolicy from './watch/alarmPolicy';
import watchAttendence from './watch/attendence';
import watchDaka from './watch/daka';
import watchLine from './watch/line';

export default {
    antiAddictionConfiguration,
    cpArgExport,
    demo,
    gameConfigPackagePlanManager,
    gameConfigActivityPageManager,
    gameConfigBaseInfo,
    gameConfigCommonInfo,
    gameConfigServer,
    index,
    ipBlock,
    ipBlockView,
    noAccess,
    notfind,
    payPackageSetting,
    pushPushPlan,
    pushPushPlanDetail,
    pushPushPlanManager,
    pushPushPlanOperate,
    pushCes,
    pushDetail,
    pushOperateLoginBanUserList,
    pushTrysend,
    queryActivityOrderDetail,
    queryActivityOrderList,
    queryActivityOrderResend,
    queryLoginList,
    queryPay,
    queryReg,
    querySdkReleaseRecord,
    queryTerminal,
    queryUser,
    rechargeCreateRechargeCode,
    rechargePushRechargeCode,
    rechargeRechargeCodeList,
    riskManagementAutoBanSetting,
    riskManagementDetail,
    riskManagementIpBlock,
    riskManagementIpBlockView,
    riskManagementLoginBan,
    riskManagementOperateLoginBanUserList,
    sdkAdjustToken,
    sdkConfigEdit,
    sdkConfigList,
    sdkDialog,
    sdkReleasesEdit,
    sdkReleasesEdit1,
    sdkReleasesList,
    systemSdkVersion,
    watchAlarmGroup,
    watchAlarmPolicy,
    watchAttendence,
    watchDaka,
    watchLine
}



// WEBPACK FOOTER //
// ./website/store/modules/autoload.js